<template>
  <div>
    <headers :tabIndex="1"></headers>
    <div class="news-detail-box">
        <div class="detail-left"  >
          <div class="detail-left-title">{{obj.title}}</div>
          <div class="detail-left-date">{{obj.publishDate}}</div>
          <div class="detail" v-html="obj.h5Content"></div>
        </div>
    </div>
    <footers></footers>
  </div>
</template>


<script>
  import headers from "@/components/wap/header1"
  import footers from "@/components/wap/footer"
  import axios from "axios";
  export default {
    name: 'wapNews',
    components:{headers,footers},
    data() {
      return{
        id:"",
        obj:{},
      }
    },
    mounted() {
      this.id = this.$route.query.id;
      this.getNewsDetail()
    },
    beforeDestroy() {
    },
    methods:{
      getNewsDetail(){
        axios.get(this.pageUrl+`/news/${this.id}`).then(res=>{
          this.obj=res.data.data;
        })
      },
    }
  }
</script>

<style scoped>
  .news-detail-box{
    margin-top: 1rem;
    padding: 0.4rem 0.4rem;
    min-height: 10rem;
  }
  .detail-left-title{
    font-size: 0.28rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
  }
  .detail-left-date{
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
    margin-top: 0.2rem;
  }
  .news-detail-box .detail{
    font-size: 0.24rem;
    margin-top: 0.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/news/wapDetail.vue